import { Directive, DirectiveBinding } from 'vue'

// eslint-disable-next-line no-magic-numbers
const KB_MIN_LIMIT = 1024
// eslint-disable-next-line no-magic-numbers
const MB_MIN_LIMIT = 1024 * 1024
// eslint-disable-next-line no-magic-numbers
const GB_MIN_LIMIT = 1024 * 1024 * 1024

export interface SpeedFormatOptions {
  unit: string
  decimals?: number,
  showUnit?: boolean
}

// eslint-disable-next-line complexity
export const speedFormat = function (value: number, options: SpeedFormatOptions) {
  let decimals = 2
  let unit
  let showUnit = true
  let data

  value = value || 0

  if (options.decimals !== undefined) {
    decimals = options.decimals
  }

  if (options.showUnit !== undefined) {
    showUnit = options.showUnit
  }

  if (options.unit) {
    unit = options.unit
  } else {
    value > GB_MIN_LIMIT ? unit = 'GB' : (value > MB_MIN_LIMIT ? unit = 'MB' : unit = 'KB')
  }

  switch (unit) {
    case 'GB':
      data = `${(value / GB_MIN_LIMIT).toFixed(decimals)}${showUnit ? 'GB' : ''}`
      break
    case 'MB':
      data = `${(value / MB_MIN_LIMIT).toFixed(decimals)}${showUnit ? 'MB' : ''}`
      break
    case 'KB':
      data = `${(value / KB_MIN_LIMIT).toFixed(decimals)}${showUnit ? 'KB' : ''}`
      break
  }

  return data
}

function directiveAction (el: HTMLElement, bindings: DirectiveBinding) {
  let value = bindings.value
  let decimals = 2
  let unit
  let showUnit = true

  if (/object/i.test(typeof bindings.value)) {
    value = bindings.value.value
    if (bindings.value.unit) {
      unit = bindings.value.unit
    }

    if (bindings.value.decimals !== undefined) {
      decimals = bindings.value.decimals
    }

    if (bindings.value.showUnit !== undefined) {
      showUnit = bindings.value.showUnit
    }
  }

  el.innerText = speedFormat(value, {
    unit,
    decimals,
    showUnit
  })
}

/**
 * 网速、容量格式化指令
 * @example
 * <span v-speed-format="343243"></span>
 *
 * @example
 * <span v-speed-format="{value: 434234, unit: 'MB'}"></span>
 * <span v-speed-format="{value: 434234, unit: 'MB', decimals: 0}"></span>
 */
export const SpeedFormatDirective: Directive = {
  mounted (el: HTMLElement, bindings: DirectiveBinding) {
    directiveAction(el, bindings)
  },
  updated (el: HTMLElement, bindings: DirectiveBinding) {
    directiveAction(el, bindings)
  }
}
